module.exports = __webpack_public_path__ + "img/thanks_en.d6e96a77.png";